// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3so5I","list":"BalanceDue_list__1nI91","listRow":"BalanceDue_listRow__wmdUt","total":"BalanceDue_total__1ETW5"};